const getFileBlob = (href) => {
  const byteCharacters = atob(href);
  const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: 'application/pdf' });
};

export default getFileBlob;
